






































































































































import { Component, Vue, Watch, Prop, Ref } from "vue-property-decorator";
import { storeDiagnosa } from "@/store/modules/diagnosa";
import http from "@/axios/http-common";
import { userModule } from "@/store/modules/user";
import { storeResume } from "@/store/modules/resume";
import { appModule } from "@/store/modules/app";
import storeBilling from "@/store/modules/Billing";
import Billing from "@/services/Billing";

@Component
export default class InputDiagnosisICD extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop() save!: boolean;
  @Prop() isShowed!: boolean;

  @Ref() searchDiagField!: HTMLInputElement;
  @Ref() diagText!: Array<HTMLInputElement>;

  searchResultDiag = null;
  diagnosa = [];
  arrayDiag = [];
  searchStringDiag = "";
  searchStringDiag2 = "";
  editedItemDiag = this.diags?.diagnosis ?? [];
  editedIndexDiag = null;
  _timerId;
  dokter = {};
  alert = "";
  saving = false;

  mounted() {
    // this.editedItemDiag = this.diags?.diagnosis ?? [];
    // console.log("mounted input diagnosis icd", this.editedItemDiag);
    this.$nextTick(() => {
      this.searchDiagField.focus();
    });
  }

  savingDiag(val) {
    this.saving = val;
    this.$emit("saving-diag", val);
  }

  get statediagnosa() {
    return storeDiagnosa.diagnosa;
  }

  get stateuser() {
    return userModule.user;
  }

  get dataResume() {
    return storeResume.resume;
  }

  get diags() {
    return storeBilling.diagnosis;
  }

  searchDiag(termSearch) {
    http
      .getDataParam("/referensi/diagnosis-icd/search", {
        params: { term: termSearch }
      })
      .then(res => {
        // console.log(res.data);
        this.diagnosa = res.data;
      })
      .finally();
  }

  @Watch("searchStringDiag")
  searched() {
    this.diagnosa = [];
    clearTimeout(this._timerId);
    this._timerId = setTimeout(() => {
      if (this.searchStringDiag === null || this.searchStringDiag.length < 2)
        return;

      this.searchDiag(this.searchStringDiag);
    }, 500);
  }
  @Watch("searchStringDiag2")
  searchedEdit() {
    this.diagnosa = [];
    clearTimeout(this._timerId);
    this._timerId = setTimeout(() => {
      if (this.searchStringDiag2 === null || this.searchStringDiag2.length < 2)
        return;
      this.searchDiag(this.searchStringDiag2);
    }, 500);
  }

  @Watch("diags")
  changeDiagnosis() {
    console.log("change hasil diagnosis input icd", this.diags.diagnosis);
    if (this.diagnosa.length == 0 && this.diags && this.diags.register_id) {
      this.editedItemDiag = this.diags.diagnosis;
    }
  }

  @Watch("save")
  changeSave(val) {
    if (val) {
      this.simpanDiag();
    }
  }

  @Watch("isShowed")
  changeIsShowed(val) {
    // console.log("is showed", val);
    if (val) {
      this.$nextTick(() => {
        this.searchDiagField.focus();
      });
    }
  }

  itemChangeDiag(e) {
    this.editedItemDiag.push({
      nama: e.dx,
      kode: e.kddx,
      kasus: null,
      text: null,
      tgl: new Date().toISOString().substr(0, 10),
      unit_id: this.stateuser.unit_id,
      dr_id: this.stateuser.id
    });
    this.arrayDiag.push({ kode: e.kddx, kasus: null });
    this.$nextTick(() => {
      this.searchStringDiag = "";
      this.searchResultDiag = null;
      this.diagnosa = [];
      this.diagText[this.diagText.length - 1].focus();
    });
  }
  toggleEditDiag(i, diag) {
    if (
      this.stateuser.id == this.dataResume[0]?.dpjp?.id ||
      this.stateuser.id == diag.dr_id
    ) {
      if (this.editedIndexDiag !== i) {
        this.editedIndexDiag = i;
      } else {
        this.editedIndexDiag = null;
      }
    } else {
      alert("tidak bisa mengubah diagnosa yang dicatat DPJP!");
      console.log(this.stateuser.id, diag);

      this.editedIndexDiag = null;
    }
  }
  editItemChangeDiag(e) {
    Object.assign(this.editedItemDiag[this.editedIndexDiag], {
      nama: e.dx,
      kode: e.kddx,
      kasus: null,
      tgl: new Date().toISOString().substr(0, 10),
      unit_id: this.stateuser.unit_id,
      dr_id: this.stateuser.id
    });
    this.$set(this.arrayDiag, this.editedIndexDiag, {
      kode: e.kddx,
      kasus: this.editedItemDiag[this.editedIndexDiag].kasus
    });

    this.$nextTick(() => {
      this.searchStringDiag = "";
      this.searchResultDiag = null;
    });
  }
  delDiag(index) {
    this.editedItemDiag.splice(index, 1);
    this.arrayDiag.splice(index, 1);
    this.editedIndexDiag = null;
  }

  clearform() {
    this.editedItemDiag = [];
    this.arrayDiag = [];
  }

  truncate(input) {
    if (input.length > 40) {
      return input.substring(0, 40) + "...";
    }
    return input;
  }

  isDiagDisabled(diag) {
    if (
      this.stateuser.id == this.dataResume[0]?.dpjp?.id ||
      this.stateuser.id == diag.dr_id
    ) {
      return false;
    } else {
      return true;
    }
  }

  get params() {
    const inp = {
      register_id: this.register,
      pasien_rm: this.rm,
      diagnosis: this.editedItemDiag
    };
    return inp;
  }

  simpanDiag() {
    if (!this.saving) {
      this.savingDiag(true);

      Billing.postDiagnosa(this.params)
        .then(dt => {
          if (dt["status"] != 1) {
            appModule.sendErrorAlert(dt["message"]);
          } else {
            appModule.NoticeDelay("Berhasil Simpan Diagnosis");
            storeBilling.getDiagnosis(this.register);
            this.$emit("success");
          }
        })
        .finally(() => {
          this.savingDiag(false);
        });
    }
  }
}
